import React, {useEffect, useState} from 'react';
// import Avatar from '@material-ui/core/Avatar'
import {useDispatch, useSelector} from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {userSignOut} from 'actions/Auth';
import IntlMessages from 'util/IntlMessages';
import PersonSharpIcon from '@material-ui/icons/PersonSharp';
import {Badge} from "reactstrap";
import {bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import {fetchCustomers, setCustomerInView} from "../../../actions";
import {CircularProgress, Dialog, DialogContent, DialogTitle, } from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../../customBreachBits/accents/BRCustomizedTooltip";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContentText from "@material-ui/core/DialogContentText";
import NewMasqueradeSessionForm from "../../../containers/NewMasqueradeSessionForm"
import OnboardingProgressMenuItem from "../../customBreachBits/info/OnboardingProgressMenuItem";
// import PersonalSettingsDialog from "../../customBreachBits/settings/PersonalSettingsDialog";
import UserSettingsWidget from "../../../app/routes/dashboard/routes/settingsSubscription/UserSettingsWidget";
import {Button, DialogActions} from "@mui/material";

const UserInfo = () => {

    /* Anatomy of the User object returned from /me as of Sep 2020 */
//     {
//     "user": {
//         "id": 5,
//             "username": "foster.davis",
//             "first_name": "Foster",
//             "last_name": "Davis",
//             "email": "foster@breachbits.com",
//             "is_active": true,
//             "is_activated": true,
//             "needs_password_reset": false,
//             "date_joined": "2020-06-30 17:11:29.427329"
//     },
//     "customers": [],
//         "roles": [
//         {
//             "id": 5,
//             "user": 5,
//             "role": {
//                 "id": 1,
//                 "name": "admin",
//                 "description": "Full privileges to add, remove, edit and view all data."
//             },
//             "created_date": "2020-09-22 11:39:00",
//             "created_by": 1
//         },
//         {
//             "id": 6,
//             "user": 5,
//             "role": {
//                 "id": 2,
//                 "name": "staff",
//                 "description": "Access to view customer data, but limited access to remove and edit data."
//             },
//             "created_date": "2020-09-22 11:39:00",
//             "created_by": 1
//         }
//     ]
// }

  const dispatch = useDispatch();

  const [anchorE1, setAnchorE1] = useState(null);
  const [open, setOpen] = useState(false);
    const {authUser, loadingMasquerade} = useSelector(({auth}) => auth);
    const {didJustMasquerade} = useSelector(({auth}) => auth.appMisc);
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const [singleCustomerName,setSingleCustomerName]=useState('');
    const [openSettings, setOpenSettings] = useState(false);
  //const wholeState = useSelector(({everything}) => everything);

    const isAdmin = isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");
    const isPartner = isCurrentUserMemberOf(authUser, "partner");
    const isTrustedAgent = bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel3");
    const isAdministratorForAnyEntity = bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel4");
    const isCustomer = isCurrentUserMemberOf(authUser, "customer");
    const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk");


    const customer = customers ? customerInView ? customers[customerInView] : null : null;


    const handleClick = event => {
    setOpen(true);
    setAnchorE1(event.currentTarget);
  };

  const handleRequestClose = () => {
    setOpen(false);
  };

  const handleOpenSettings = () =>{
      setOpenSettings(true);
  }

  const handleCloseSettings = () =>{
      setOpenSettings(false);
  }

    useEffect( () => {
        if (customers == null) {
            dispatch(fetchCustomers());
        }
        if (customers && customerInView === null && authUser && authUser.customers[0] && isCustomer) {
            const defaultId = authUser.customers[0].customer
            dispatch(setCustomerInView(defaultId));
        }
        // console.log("customers", customers, "customerInView", customerInView, !isCurrentUserMemberOf(authUser, "admin"));
        if (customers && customerInView && customers[customerInView] && !isAdmin) {
            setSingleCustomerName(customers[customerInView].CustomerName);
        }

        //check to close the modal
        if(didJustMasquerade) {
            setMasqueradeOpen(false);
        }
    }, [customers, authUser, customerInView, dispatch, didJustMasquerade, loadingMasquerade]);

  const logoutMessage = <IntlMessages id={"signOut.normal"}/>;

  //Masquerade Form
    const [masqueradeOpen, setMasqueradeOpen] = useState(didJustMasquerade ? didJustMasquerade : false);

    const handleMasqueradeFormOpen = () =>{
        setMasqueradeOpen(true);
        // setCycleInView(myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.settings.last_cycle_id : null)
        // setCycleObj(myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.cycles[myEntity.settings.last_cycle_id] : null)
    }

    const handleMasqueradeFormClose = () => {
        setMasqueradeOpen(false);
        // setCycleInView(null);
        // setCycleObj(null);
    }

    const masqueradeDialog = masqueradeOpen
        ? <Dialog open={masqueradeOpen}
            // fullScreen
            maxWidth={"xl"}
            onClose={handleMasqueradeFormClose}
            aria-labelledby="form-dialog-title">
        <DialogTitle id="customized-dialog-title" onClose={handleMasqueradeFormClose}>
            <div className={"row"}>

                <div className={"col-6 p-0 m-0"}>

                </div>
                <div className={"col-10"}/>

                <div className={"col-1 text-right"}>
                    {loadingMasquerade &&
                        <CircularProgress size={36} disableShrink/>
                    }
                </div>

                <div className={"col-1 text-right"}>
                    {/*<IconButton*/}
                    {/*    // variant={"s"}*/}
                    {/*    // color={"lightest-gray"}*/}
                    {/*    onClick={()=>window.print()}>*/}
                    {/*    <BBIconPrinterOutput/>*/}
                    {/*    /!*PRINT*!/*/}
                    {/*</IconButton>*/}

                    <IconButton
                        // variant={"s"}
                        // color={"lightest-gray"}
                        onClick={()=>handleMasqueradeFormClose()}>
                        <CloseIcon/>
                    </IconButton>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-12 text-center"}>
                    <h1>Masquerade</h1>
                    <p>Admins can select a user or a customer and view the dashboard just as that user or customer demo account sees it.</p>
                    <p>Once you make a selection, the dashboard will reload. You will be able to return to the admin view without logging back in until your session expires.</p>
                </div>
            </div>
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                <div className={"border-2 p-3 bg-lightest-gray"}>
                    <div style={{height: '90%'}}>
                        <NewMasqueradeSessionForm/>

                    </div>
                </div>

            </DialogContentText>
            {/*<div className={"text-center m-1"}  style={{fontSize: "smaller"}}>*/}
            {/*    <p>©2019-2021 BreachBits, Inc. BreachRisk and other marks are servicemarks or trademarks of BreachBits, Inc. </p>*/}
            {/*    <p>1125 West Street, Suite 429, Annapolis, MD, 21401, (443) 440-5605.</p>*/}
            {/*    <p>Disclaimer: BreachBits is a third-party cybersecurity assessment firm; services rendered are not a substitute for a dedicated information security team.*/}
            {/*        Risk assessments that may appear in this report are a professional recommendation and are not a guarantee of your risk from data breaches, theft, destruction, degradation or other malicious activities.*/}
            {/*        By using BreachBits subscriptions, pilots, demonstrations, and other services, you acknowledge that no amount of security actions or red team activities can discover all possible vulnerabilities and/or eliminate all risk.*/}
            {/*        Many factors contribute to cybersecurity risk, and many of these factors are beyond the control of your organization - and beyond the scope of any BreachBits risk assessment. The risk of malicious cyber activity can never be zero;*/}
            {/*        your organization is always at risk from malicious cyber actors. For more information regarding the BreachBits limits of liability, please refer to your <a href={"https://www.breachbits.com/sla"}>Service Level Agreement.</a></p>*/}
            {/*</div>*/}
        </DialogContent>

    </Dialog>
        : null;

    const settingsDialog =  <Dialog open={openSettings}
                                    maxWidth={"lg"}
                                    fullWidth={true}
                                    onClose={()=>handleCloseSettings()}
                                    aria-labelledby="form-dialog-title">
        <DialogTitle className={"bg-lightest-gray"}>
            Settings & Personal Preferences
            <IconButton
                onClick={()=>handleCloseSettings()}
                aria-labelledby={"close"}
                className={"close"}>
                <CloseIcon/>
            </IconButton>
        </DialogTitle>
        <DialogContent className={"bg-lightest-gray"}>
            <UserSettingsWidget customer={customer} authUser={authUser}/>
        </DialogContent>
        <DialogActions className={"bg-lightest-gray"}>
            <Button onClick={()=>handleCloseSettings()}>
                Close
            </Button>
        </DialogActions>
    </Dialog>









  return (
      <>
      <div className="user-profile tourStepUserFunctions" >
    <div className="d-flex flex-row align-items-center">
        {/*TODO: Add Avatar picture*/}
      <PersonSharpIcon
        className="user-avatar "
        onClick={handleClick}
        cursor={"pointer"}
      />
      <div className="user-detail">
          <h4 className="user-name d-flex"
              id={"user-menu-toggle-button"}
              onClick={handleClick}><span className='text-truncate'>{(authUser && authUser.user) ? `${authUser.user.first_name} ${authUser.user.last_name}` : "Loading..."}</span> <i
          className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>
          </h4>
      </div>
      <Menu className="user-info"
            id="simple-menu"
            anchorEl={anchorE1}
            open={open}
            onClose={handleRequestClose}
            PaperProps={{
              style: {
                minWidth: 120,
                paddingTop: 0,
                paddingBottom: 0
              }
            }}
      >
        {/*<MenuItem onClick={handleRequestClose}>*/}
        {/*  <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>*/}
        {/*  <IntlMessages id="popup.profile"/>*/}
        {/*</MenuItem>*/}
        {/*<MenuItem onClick={handleRequestClose}>*/}
        {/*  <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>*/}
        {/*  <IntlMessages id="popup.setting"/>*/}
        {/*</MenuItem>*/}
          <MenuItem>
              <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>
              <span className='text-truncate'>{(authUser && authUser.user) ? `${authUser.user.username}` : "Loading..."}</span>
          </MenuItem>
        <MenuItem
              component="a"
              href={"/password"}
              onClick={() => {
              handleRequestClose();
          }}>
              <i className="zmdi zmdi-key zmdi-hc-fw mr-2"/>
              <IntlMessages id="appModule.changePassword.title"/>
          </MenuItem>
          {(authUser && authUser.user && isAdmin) &&
                  <MenuItem onClick={() => {
                      handleRequestClose();
                      handleMasqueradeFormOpen();
                  }}>
                      <i className="zmdi zmdi-eye zmdi-hc-fw mr-2"/>
                      {/*<Tooltip title={<IntlMessages id="appModule.masquerade.details"/>}>*/}
                          <span><IntlMessages id="appModule.masquerade.title"/></span>
                      {/*</Tooltip>*/}

                  </MenuItem>
          }
          <MenuItem onClick={()=> {
              handleRequestClose();
              handleOpenSettings();
          }}>
              <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>
              {/*<Tooltip title={<IntlMessages id={"appModule.settings.details"}/>}>*/}
                  <span><IntlMessages id={"appModule.settings.title"}/></span>
              {/*</Tooltip>*/}
          </MenuItem>
        <MenuItem id={"logout-menu-item"}
            onClick={() => {
          handleRequestClose();
          dispatch(userSignOut({logoutMessage}));
        }}>
          <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>
          <IntlMessages id="popup.logout"/>
        </MenuItem>
      </Menu>

    </div>
    <div className={"d-flex flex-wrap justify-content-start"}>


        {isAdmin
            ? <Badge color="danger"><IntlMessages id={"badge.role.admin"}/></Badge>
            : null
        }
        {isTrustedAgent
            ? <Badge color="secondary">
                <small>
                    <IntlMessages id={"badge.role.trustedAgent"}/>
            </small>
        </Badge>
            : null
        }
        {isAdministratorForAnyEntity
            ? <Badge color="secondary"><small>
                <IntlMessages id={"badge.role.administratorForEntity"}/>
            </small></Badge>
            : null
        }
        {isPartner
            ? <Badge color="secondary"><IntlMessages id={"badge.role.partner"}/></Badge>
            : null
        }
        {isStaff
            ? <Badge color="secondary"><IntlMessages id={"badge.role.staff"}/></Badge>
            : null
        }
        {masqueradeDialog}
        {openSettings && settingsDialog}

    </div>

    </div>
          {!(isAdmin || isStaff || isPartner) && (
              <div className={"customer-name align-items-center mx-auto"}>
                  {singleCustomerName && (
                      <div className={" animated fadeIn animation-duration-20"}>
                          <h4 className={""} > {singleCustomerName}</h4>
                          {/*<h4 className={""} > Bluth Company</h4>*/}
                      </div>
                  )}
                  {!singleCustomerName && (
                      <div>
                          <h4 className={"ml-2"}> &nbsp;</h4>
                      </div>
                  )}
              </div>
          )}
          {!(isAdmin || isStaff || isPartner) && isBRBusinessCustomer &&
              <div className={"customer-name align-items-center mx-auto row my-0 py-0 text-center"}>
              <div className={"col-1 my-0 py-0"}> </div>
              <div className={"col-10 animated fadeIn animation-duration-20 my-0 py-0"}>
                  <h5 className={""}><OnboardingProgressMenuItem/> </h5>
              </div>
              <div className={"col-1 my-0 py-0"}> </div>

          </div>}
    </>
  );
};

export default UserInfo;


